import { Icon } from "@circle-react-shared/Icon";

import { t } from "@/i18n-js/instance";
import type { SpaceListButtonProps } from "@/react/components/Spaces/SidebarV2/CommunityMenu/SpaceList/SpaceListButton";
import { SpaceListButton } from "@/react/components/Spaces/SidebarV2/CommunityMenu/SpaceList/SpaceListButton";

interface JoinSpacesButtonView extends SpaceListButtonProps {}

export const JoinSpacesButtonView = ({ ...rest }: JoinSpacesButtonView) => (
  <SpaceListButton {...rest}>
    <Icon size={16} type="16-add-new" />
    <span className="mx-2">{t("join_a_space")}</span>
  </SpaceListButton>
);
